import React, {Suspense, useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router';
import DataProductsList from "../../pages/admin/data_products/DataProductsList"

function DataProducts(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={DataProductsList}/>
      </Switch>
    </Suspense>
  )
}

export default DataProducts
